import { useDebounceFn } from 'ahooks';
import { Divider, Input, Space } from 'antd';
import { PartialSKU } from 'domains/skuDomain';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QUANTITY_DEBOUNCE_MILLISECOND } from 'utils/constants';

type Props = {
  sku: PartialSKU;
  updateCurItem: (item: PartialSKU) => Promise<void>;
};

export const SkuDisplayName = (props: Props) => {
  const { sku, updateCurItem } = props;
  const { t } = useTranslation();
  const [displayName, setDisplayName] = useState<string>();
  const [displayNamePlural, setDisplayNamePlural] = useState<string>();
  useEffect(() => {
    setDisplayName(sku.displayName);
    setDisplayNamePlural(sku.displayNamePlural);
  }, [sku]);
  const { run: runUpdateCurItem, cancel: cancelUpdateCurItem } = useDebounceFn(
    async () => {
      updateCurItem({
        ...sku,
        displayName,
        displayNamePlural,
      });
    },
    { wait: QUANTITY_DEBOUNCE_MILLISECOND }
  );
  return (
    <>
      <div className="single-sku-detail-form-row">
        <Space>
          <label>{t('platform.sku.form.label.displayName')}:</label>
          <div
            style={{
              position: 'relative',
              minWidth: '220px',
            }}
          >
            <Input
              disabled={sku.readonly}
              value={displayName}
              onChange={(e) => {
                setDisplayName(e.target.value);
                cancelUpdateCurItem();
                runUpdateCurItem();
              }}
            />
            {Boolean(!displayName) && (
              <div
                className="ant-form-item-explain-error"
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 35,
                }}
              >
                {t('platform.sku.displayNameRequired')}
              </div>
            )}
          </div>
          <Divider type="vertical" />
          <label>{t('platform.sku.form.label.displayNamePlural')}:</label>
          <div
            style={{
              position: 'relative',
              minWidth: '240px',
            }}
          >
            <Input
              disabled={sku.readonly}
              value={displayNamePlural}
              onChange={(e) => {
                setDisplayNamePlural(e.target.value);
                cancelUpdateCurItem();
                runUpdateCurItem();
              }}
            />
            {Boolean(!displayNamePlural) && (
              <div
                className="ant-form-item-explain-error"
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 35,
                }}
              >
                {t('platform.sku.displayNamePluralRequired')}
              </div>
            )}
          </div>
        </Space>
      </div>
    </>
  );
};
